import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "count", "toggleButton"]
  static values = {
    showAll: { type: Boolean, default: false }
  }

  connect() {
    this.updateDisplay()
  }

  toggle() {
    this.showAllValue = !this.showAllValue
    this.updateDisplay()
    this.updateButton()
  }

  updateDisplay() {
    this.rowTargets.forEach((row) => {
      const quantity = parseInt(row.dataset.quantity || "0")
      const shouldShow = this.showAllValue || quantity > 0
      if (shouldShow) {
        row.classList.remove("hidden")
      } else {
        row.classList.add("hidden")
      }
    })
    this.updateCount()
  }

  updateCount() {
    const visibleCount = this.rowTargets.filter((row) => {
      const quantity = parseInt(row.dataset.quantity || "0")
      const shouldShow = this.showAllValue || quantity > 0
      return shouldShow
    }).length

    const totalCount = this.rowTargets.length

    if (this.hasCountTarget) {
      this.countTarget.textContent = `(${visibleCount} z ${totalCount})`
    }
  }

  updateButton() {
    if (this.hasToggleButtonTarget) {
      if (this.showAllValue) {
        this.toggleButtonTarget.textContent = "Pokaż tylko z dodatnim stanem"
      } else {
        this.toggleButtonTarget.textContent = "Pokaż wszystkie"
      }
    }
  }
}
